
export class Sort {
    private sortorder = 1;
    private collator = new Intl.Collator(undefined, {
        numeric: true, sensitivity: "base"
    });
    constructor() {
    }
    public startSort(property: string, order: string, type = "") {
        if (order === "desc") {
            this.sortorder = -1;
        }
        return (a: any, b: any) => {
            const aV = property.split('.').reduce((prev, curr) => prev?.[curr], a);
            const bV = property.split('.').reduce((prev, curr) => prev?.[curr], b);
            if (type === "date") {
                return this.sortData(new Date(aV), new Date(bV));
            } else {
                return this.collator.compare(aV, bV) * this.sortorder;
            }
        }
    }

    private sortData(a: any, b: any) {
        if (a < b) {
            return -1 * this.sortorder;
        } else if (a > b) {
            return 1 * this.sortorder;
        } else {
            return 0 * this.sortorder;
        }
    }
}